import React, { useState } from 'react';
import { initializeApp, deleteApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { firestore, firebaseConfig } from '../../firebase/config';
import { doc, setDoc } from 'firebase/firestore';
import './GerenciarUsuarios.css';

function CriarUsuarioModal({ onClose, onSuccess }) {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [perfil, setPerfil] = useState('agente');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    let secondaryApp;
    try {
      // Cria um app secundário para não deslogar o usuário atual
      secondaryApp = initializeApp(firebaseConfig, "Secondary");
      const secondaryAuth = getAuth(secondaryApp);

      // Cria a conta no Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(secondaryAuth, email, senha);
      const newUser = userCredential.user;

      // Salva os dados adicionais no Firestore usando o banco principal (que tem permissão)
      const userRef = doc(firestore, 'usuarios', newUser.uid);
      await setDoc(userRef, {
        nome: nome,
        email: email,
        perfil: perfil,
        status: 'ativo',
        criadoEm: new Date().toISOString()
      });

      // Sucesso
      onSuccess();
    } catch (err) {
      console.error("Erro ao criar usuário:", err);
      if (err.code === 'auth/email-already-in-use') {
        setError("Este email já está em uso.");
      } else if (err.code === 'auth/weak-password') {
        setError("A senha deve ter pelo menos 6 caracteres.");
      } else {
        setError("Erro ao criar o usuário. Tente novamente.");
      }
    } finally {
      // Deleta o app secundário para limpar a memória
      if (secondaryApp) {
        await deleteApp(secondaryApp);
      }
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content usuario-modal">
        <h3>Cadastrar Novo Usuário</h3>
        
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nome Completo</label>
            <input 
              type="text" 
              value={nome} 
              onChange={(e) => setNome(e.target.value)} 
              required 
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input 
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required 
            />
          </div>

          <div className="form-group">
            <label>Senha</label>
            <input 
              type="password" 
              value={senha} 
              onChange={(e) => setSenha(e.target.value)} 
              required 
              minLength="6"
            />
          </div>

          <div className="form-group">
            <label>Perfil de Acesso</label>
            <select value={perfil} onChange={(e) => setPerfil(e.target.value)} required>
              <option value="agente">Agente</option>
              <option value="supervisor">Supervisor</option>
              <option value="laboratorio">Laboratório</option>
              <option value="gestor">Gestor</option>
            </select>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Cadastrando...' : 'Cadastrar Usuário'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CriarUsuarioModal;
